import { useEffect } from "react";
import { initializeTelegramWindow, supportsTelegramVersion } from "./telegramWindow";

export function useTelegram() {
  useEffect(() => {
    const app = window.Telegram?.WebApp;
    const inside = Boolean(app?.initData);
    const root = document.documentElement;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const sync = () => {
      root.dataset.telegram = String(inside);
      root.dataset.fullscreen = String(inside && Boolean(app?.isFullscreen));
      const preference = root.dataset.themePreference;
      const dark = preference === "dark" || (preference !== "light" && (inside ? app?.colorScheme === "dark" : media.matches));
      root.dataset.nextTheme = dark ? "dark" : "light";
      root.style.colorScheme = dark ? "dark" : "light";
      root.style.setProperty("--next-viewport", `${window.visualViewport?.height || window.innerHeight}px`);
      for (const [name, inset] of [["safe", app?.safeAreaInset], ["content", app?.contentSafeAreaInset]] as const) {
        for (const side of ["top", "right", "bottom", "left"] as const) {
          const value = inside ? inset?.[side] : 0;
          if (typeof value === "number" && Number.isFinite(value)) root.style.setProperty(`--next-${name}-${side}`, `${Math.max(0, value)}px`);
          else root.style.removeProperty(`--next-${name}-${side}`);
        }
      }
      window.dispatchEvent(new Event("estet:viewport"));
      const color = dark ? "#0a0a0a" : "#ffffff";
      const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
      if (meta) meta.content = color;
      if (inside && app && supportsTelegramVersion(app, "6.1")) {
        try { app.setHeaderColor?.(supportsTelegramVersion(app, "6.9") ? color : "bg_color"); app.setBackgroundColor?.(color); } catch { /* Older Telegram clients can reject custom colours. */ }
      }
    };
    const events = ["themeChanged", "viewportChanged", "safeAreaChanged", "contentSafeAreaChanged", "fullscreenChanged", "activated"];
    sync();
    if (inside) for (const event of events) app?.onEvent?.(event, sync);
    const cleanupWindow = initializeTelegramWindow(app);
    media.addEventListener("change", sync);
    window.visualViewport?.addEventListener("resize", sync);
    window.visualViewport?.addEventListener("scroll", sync);
    window.addEventListener("resize", sync);
    window.addEventListener("estet:theme", sync);
    return () => {
      cleanupWindow();
      if (inside) for (const event of events) app?.offEvent?.(event, sync);
      media.removeEventListener("change", sync);
      window.visualViewport?.removeEventListener("resize", sync);
      window.visualViewport?.removeEventListener("scroll", sync);
      window.removeEventListener("resize", sync);
      window.removeEventListener("estet:theme", sync);
    };
  }, []);
}
